module.exports = __webpack_public_path__ + "img/brainfit_5.d7b59dc3.jpg";